import React from 'react'
import Rider from '../components/Rider/Rider'
import { components } from 'react-select'
import driverbreadcrumbs from "../assets/img/riderberadcrums.jpg";
import Breadcumb from '../components/Breadcumb';
import DownloadArea from '../components/DownloadArea';

const RiderPage = () => {
  return (
    <div>
      <Breadcumb  pageTitle="Ride with CabandGo" backgroundImage={driverbreadcrumbs} />
      <Rider />
      <DownloadArea />
    </div>
  )
}

export default RiderPage
